import styles from "./ContentList.module.css";
import { QueryTableRow } from "src/components/page-components/BrowseQueriesPage/List/QueriesList";
import { toQueryElementType } from "src/components/page-components/Library/shared/Query/queryElement";
import useQueriesFavorites from "src/components/page-components/BrowseQueriesPage/api/useQueriesFavorites";
import useDashboardsFavorites from "src/components/page-components/BrowseDashboardsPage/api/useDashboardsFavorites";
import { DashboardTableRow } from "src/components/page-components/BrowseDashboardsPage/List/DashboardsList";
import { toDashboardElementType } from "src/components/page-components/Library/shared/Dashboard/dashboardElement";
import { useGetFolderContent } from "src/components/page-components/Library/hooks/useGetFolderContent";

interface Props {
  content: ReturnType<typeof useGetFolderContent>;
  refetchContent?: () => Promise<void> | void;
}

export function MixedContentList(props: Props) {
  const { content, refetchContent } = props;
  const results = content.data?.get_content.results;

  const queries = results?.filter((element) => element.type === "query") ?? [];
  const queriesFavorites = useQueriesFavorites(queries.map((q) => q.id));

  const dashboards =
    results?.filter((element) => element.type === "dashboard") ?? [];
  const dashboardsFavorites = useDashboardsFavorites(
    dashboards.map((d) => d.id)
  );

  return (
    <table className={styles.table}>
      <tbody>
        {results?.map((element) => {
          if (element.type === "query" && element.query) {
            return (
              <QueryTableRow
                key={element.query.id}
                query={toQueryElementType(element.query)}
                favorites={queriesFavorites}
                origin="creations"
                refetchFolderContent={refetchContent}
              />
            );
          }

          if (element.type === "dashboard" && element.dashboard) {
            return (
              <DashboardTableRow
                key={element.dashboard.id}
                dashboard={toDashboardElementType(element.dashboard)}
                favorites={dashboardsFavorites}
                origin="creations"
                refetchFolderContent={refetchContent}
              />
            );
          }
        })}
      </tbody>
    </table>
  );
}
